import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import Select from 'react-select'
import {Box} from 'reactjs-admin-lte'
import {Button,ButtonToolbar,ControlLabel,FormGroup,Row,Col,FormControl,Form,Modal,InputGroup,Label} from 'react-bootstrap'
import { AsyncTypeahead } from 'react-bootstrap-typeahead'
import FontAwesome from 'react-fontawesome'
import StockStore from '../../stores/StockStore'
import GenDocStore from '../../stores/GenDocStore'
import IframeModal from '../../component/element/IframeModal'
import CKAutocomplete from '../../component/element/CKAutocomplete'
import AutopartStore from '../../stores/AutopartStore'
import WorkdocStore from '../../stores/WorkdocStore'
import PODocStore from '../../stores/PODocStore'
import ReportPurchaseOrderPage from '../report/ReportPurchaseOrderPage'
import Moment from 'moment';
import { Checkbox } from 'react-icheck';
import $ from 'jquery'
import {connect} from 'react-redux'
import SupplierPageModal from '../po/SupplierPageModal'
import ConfirmPopup from 'component/element/ConfirmPopup'
import DatePicker from 'component/element/DatePicker'
import CkTimePicker from 'component/element/CkTimePicker'
import '../stock/Stock.css'
import SearchCarButton from 'component/element/SearchCarButton'
var NotificationSystem = require('react-notification-system');


const DEFAULT_ROW = 10
class ReceptionDoc extends Component {

  constructor(...args){
    super(...args)
    let {messages} = this.props
    this.state = this.initState()
    this.pcInput = new Array(DEFAULT_ROW).fill('')
    this.car_info_timestmap = Date.now()
    this.optionsToolType = [  
      { value: 'tool', label: messages['Tool'] },      
      { value: 'genpart', label: messages['General Part'] },      
      { value: 'officemate', label: messages['Officemate'] },
      { value: 'color', label: messages['Color'] }
    ];
  }

  initState(newState){
    let state = {
      loading:false,
      mpNo:'',      
      rowBeep:-1,
      data:this.newEmptyRow(DEFAULT_ROW,'first'),
      options:[],
      doc:this.getEmptyDoc(),
      car_registration_no_list:[],
      stockApproverList:[],
      customerList:[],
      car_info:'',
      validDoc:{
        reception_by:{formValid:null,validState:null},
        response_by:{formValid:null,validState:null},
        purchase_order_no:{formValid:null,validState:null}
      },
      isSave:true,
      isRecieved:true,
      isDelivery:false,
      showPO:false,
      showFixingList:false,
      isSearchWork:false,
      checkFixingListAll:false,
      fixinglist:[],
      poreceivedlist:[],
      isSearchPOReceived:false,
      modalType:'work',
      showCustomer:false,
      part_type_option:[],
      part_by_option:[],
      showConfirm:false,
      showImStockConfirm:false,
      showExWorkConfig:false,
      showCar:false,
      location_config:[],
      showLocationConfirmDel:false,
      indexLocationDel:null,
      showLocationConfig:false,
      shelf:[],
      auto_create_stock:true,
      toolType:'genpart'
    }

    if(newState!==undefined){
      state = Object.assign(state,newState)
    }
    return state
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    $('body').on('click', ()=> { 
      if ($('.Select').hasClass('is-open'))
        $('.table-responsive').css( "overflow-x", "initial" );
      else
        $('.table-responsive').css( "overflow-x", "auto" );
    });
  }

  componentWillMount() {
    // Instantiate a Realtime client
    
  }

  componentWillReceiveProps(newProps){
    let {doc} = this.props
    if(newProps.doc!==undefined){
      if(newProps.doc.recordid!==''){
        doc = newProps.doc
        let car_info = newProps.doc.car_info
        this.setState({doc:doc,car_info:car_info})
      }else{
        //console.log('onEmptyDoc')
        this.setState({doc:this.getEmptyDoc(),car_info:'',data:this.newEmptyRow(DEFAULT_ROW)})        
      }
      
    }

    if(newProps.show && newProps.show!==this.props.show){
      this.loadWorkdocAutocompleteOfficer()
      this.loadWorkdocAutocompleteStockApprover()
    }
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  onDateChange(e) {
    let {doc} = this.state
    if (doc.added_date<16) {
      doc.added_date = e+' '+Moment().format('LT')
    } else {
      let time = doc.added_date.substring(10)
      doc.added_date = e+' '+time
    }
    this.setState({doc:doc})
  }

  onTimeChange(e) {
    let {doc} = this.state
    if (doc.added_date<16) {
      doc.added_date = Moment().format('L').replace(Moment().format('YYYY'), parseInt(Moment().format('YYYY')) + 543)+' '+e
    } else {
      let date = doc.added_date.substring(0,10)
      doc.added_date = date+' '+e
    }
    this.setState({doc:doc})
  }

  getDate(value,field) {
    if (field==='date') {
      if (value.length<10) {
        return Moment().format('L').replace(Moment().format('YYYY'), parseInt(Moment().format('YYYY')) + 543)
      } else {
        return value.substring(0,10)
      }
    } else if (field==='time') {
      if (value.length<16) {
        return Moment().format('LT')
      } else {
        return value.substring(10)
      }
    }
    return value
  }

  getToday(){
    return Moment().format('L LT').replace(Moment().format('YYYY'), parseInt(Moment().format('YYYY')) + 543);
  }

  loadCarRegistrationNo(doc) {
    let that = this
    let car = []
    if(doc.car_registration_no!==undefined && doc.car_registration_no.length>=2 && (Date.now() - that.car_info_timestmap)>2000){
      StockStore.loadCarRegistrationNo(doc.car_registration_no,function(result) {
        result.data.forEach(element => {
          car.push({
            id: element.Value,
            label: element.Name,
            car_info: element.car_info,
            work_no :element.work_no
          })
        });
        that.setState({car_registration_no_list:car})
        that.car_info_timestmap = Date.now()
      })
    }
  }

  loadWorkdocAutocompleteOfficer() {
    let that = this
    let officer = []
    WorkdocStore.loadWorkdocAutocompleteOfficer(function(result){
      result.data.forEach(element => {
        officer.push({
          id: element.Value,
          label: element.Name,
          emp_id: element.employee_id
        })
      });
      that.setState({customerList:officer})
    })  
  }

  loadWorkdocAutocompleteStockApprover() {
    let that = this
    let approver = []
    WorkdocStore.loadWorkdocAutocompleteStockApprover(function(result){
      result.data.forEach(element => {
        approver.push({
          id: element.Value,
          label: element.Name
        })
      });
      that.setState({stockApproverList:approver})
    })  
  }

  newEmptyRow(number,first=''){
    return new Array(number).fill(null).map((item,index)=>{
      return {stock_type:'',part_by:'',part_type:'',itemnum:'',bf_reception_item_id:'',reception_no:'',seq:'',detail:'',quantity:'',price_per_unit:'',amount:'',productcode:'',shelf_name:'',location_name:'',location_config_id:''}
    })
  }

  getEmptyDoc(){
    return {
      added_date:this.getToday(),
      car_registration_no:'',
      deliveryslip_no:'',
      department:'',
      description:'',
      purchase_order_no:'',
      reception_by:'',
      reception_no:'',
      remark:'',
      response_by:'',
      seq_no:'',
      status:'0',
      taxinvoice_no:'0',
      userid:'0',
      work_no:'',
      shop_name:'',
      shop_id:''
    }
  }

  loadNewDoc() {
    let that = this
    let {part_type_option,part_by_option} = this.state
    this.setState({ loading: true })
    GenDocStore.newReceptionDoc(function (result) {
      let doc = Object.assign(result.data.doc,{shop_id:'',shop_name:''})
      let data = that.newEmptyRow(DEFAULT_ROW)
      that.pcInput = new Array(data.length).fill('')
      part_type_option = result.part_type_option.map((item,index)=>{
        return {label:item.title,value:item.value}
      })
      part_by_option = result.part_by_option.map((item,index)=>{
        return {label:item.title,value:item.value}
      })
      that.setState({ location_config: result.location_config, loading: false,  data: data, doc: doc, mpNo: result.data.doc.reception_no, part_type_option:part_type_option, part_by_option:part_by_option })
    })
  }

  loadData(mpNo) {
    let that = this
    let {part_type_option,part_by_option} = this.state
    this.setState({ loading: true, mpNo: mpNo })
    GenDocStore.loadReceptionDoc(mpNo, function (result) {
      let data = result.data.itemlist
      let doc = result.data.doc 
      part_type_option = result.part_type_option.map((item,index)=>{
        return {label:item.title,value:item.value}
      })
      part_by_option = result.part_by_option.map((item,index)=>{
        return {label:item.title,value:item.value}
      })
      let isSearchWork = doc.work_no!==''?true:false
      let isSearchPOReceived = doc.purchase_order_no!==''&&doc.purchase_order_no!==null?true:false
      if (result.data.itemlist.length < DEFAULT_ROW) {
        data = data.concat(that.newEmptyRow(DEFAULT_ROW - result.data.itemlist.length))
      }
      that.pcInput = new Array(data.length).fill('')
      let car_info = doc.car_info
      that.setState({ location_config: result.location_config, car_info: car_info, part_type_option: part_type_option, part_by_option: part_by_option, loading: false,  doc: doc, data: data, isSave: true, isRecieved: true, isSearchWork: isSearchWork, isSearchPOReceived: isSearchPOReceived })
    })
  }

  onRecievedClick() {
    this.setState({showConfirm:true})
  }

  onImportStockClick() {
    this.setState({showImStockConfirm:true})
  }

  onExportWorkClick() {
    this.setState({showExWorkConfirm:true})
  }

  onConfirmRecievedClick() {
    let {isRecieved,doc,mpNo} = this.state
    let {messages} = this.props
    if (isRecieved) {
      this.setState({isRecieved:false,loading:true})
      let postData = {rc:mpNo,status:3}
      GenDocStore.updateStatusReceptionDoc(postData,(result)=>{
              if (result.status === 'OK') {            
                doc.status = '3'    
                this.setState({loading:false,isRecieved:true,doc:doc,showConfirm:false})
                this._notificationSystem.addNotification({
                  title:messages['Notice'],
                  message:'ทำรายการรับของสำเร็จ',
                  level:'info',
                  position:'tc'
                });

              }
      },(error)=>{
            this.setState({loading:false,isRecieved:true,showConfirm:false})
            this._notificationSystem.addNotification({
              title:messages['Notice'],
              message:'ทำรายการรับของไม่สำเร็จ กรุณาลองอีกครั้ง',
              level:'error',
              position:'tc'
            });
      })
    }  
  }

  onConfirmImportStockClick() {
    let {doc,mpNo,auto_create_stock,toolType} = this.state
    let {messages} = this.props
    
      this.setState({isRecieved:false,loading:true})
      let postData = {rc:mpNo,status:4,auto_create_stock:auto_create_stock,create_stock_category:toolType}
      GenDocStore.updateStatusReceptionDoc(postData,(result)=>{
              if (result.status === 'OK') {            
                doc.status = '4'    
                this.setState({loading:false,isRecieved:true,doc:doc,showImStockConfirm:false})
                this._notificationSystem.addNotification({
                  title:messages['Notice'],
                  message:'ทำรายการนำเข้าคลังสำเร็จ',
                  level:'info',
                  position:'tc'
                });

              }
      },(error)=>{
            this.setState({loading:false,isRecieved:true,showImStockConfirm:false})
            this._notificationSystem.addNotification({
              title:messages['Notice'],
              message:'ทำรายการนำเข้าอะไหล่ไม่สำเร็จ กรุณาลองอีกครั้ง',
              level:'error',
              position:'tc'
            });
      })
      
  }

  onConfirmExportWorkClick() {
    let {isRecieved,doc,mpNo} = this.state
    let {messages} = this.props
    
      this.setState({isRecieved:false,loading:true})
      let postData = {rc:mpNo,status:2}
      GenDocStore.updateStatusReceptionDoc(postData,(result)=>{
              if (result.status === 'OK') {            
                doc.status = '2'    
                this.setState({loading:false,isRecieved:true,doc:doc,showExWorkConfirm:false})
                this._notificationSystem.addNotification({
                  title:messages['Notice'],
                  message:'ทำรายการนำไปซ่อมสำเร็จ',
                  level:'info',
                  position:'tc'
                });

              }
      },(error)=>{
            this.setState({loading:false,isRecieved:true,showExWorkConfirm:false})
            this._notificationSystem.addNotification({
              title:messages['Notice'],
              message:'ทำรายการนำไปซ่อมไม่สำเร็จ กรุณาลองอีกครั้ง',
              level:'error',
              position:'tc'
            });
      })
      
  }

  onSaveClick(){
    let {doc,data} = this.state
    this.saveDoc(doc,data)  
  }

  saveDoc(doc,data){
    let {validDoc,isSave} = this.state
    let {messages} = this.props
    if (isSave) {
      this.setState({isSave:false})
      if (doc.reception_by===''||doc.reception_by===null||doc.reception_by===undefined) {
        validDoc.reception_by.formValid = 'formValidationError1'
        validDoc.reception_by.validState = 'error'
        this.setState({validDoc:validDoc,isSave:true})
        return false
      }

      if (doc.response_by===''||doc.response_by===null||doc.response_by===undefined) {
        validDoc.response_by.formValid = 'formValidationError1'
        validDoc.response_by.validState = 'error'
        this.setState({validDoc:validDoc,isSave:true})
        return false
      }

      // if (doc.purchase_order_no===''||doc.purchase_order_no===null||doc.purchase_order_no===undefined) {
      //   validDoc.purchase_order_no.formValid = 'formValidationError1'
      //   validDoc.purchase_order_no.validState = 'error'
      //   this.setState({validDoc:validDoc,isSave:true})
      //   return false
      // }

      this.setState({loading:true})    
      let postData = {doc:doc,itemlist:data}
      GenDocStore.saveReceptionDoc(postData,(result)=>{
              if (result.status === 'OK') {   
                doc.seq_no = result.seq_no             
                this.setState({loading:false,isSave:true,doc:doc})
                this._notificationSystem.addNotification({
                  title:messages['Notice'],
                  message:'บันทึกรายการสำเร็จ',
                  level:'info',
                  position:'tc'
                });

              }
      },(error)=>{
            this.setState({loading:false,isSave:true})
            this._notificationSystem.addNotification({
              title:messages['Notice'],
              message:'บันทึกรายการไม่สำเร็จ กรุณาลองอีกครั้ง',
              level:'error',
              position:'tc'
            });
      })
    }
  }
  
  onDeleteRowClick(index){ 
    let {data} = this.state
    data.splice(index,1);
    this.setState({data:data})    
  }

  summaryAmount(data){
    let amount = 0
    data.map((item,index)=>{
      amount += item.amount*1
    })
    return amount
  }

  onFormChange(index,key,e){
    let {data} = this.state
    if (key==='location_config_id') {
      if (e!==null)
        data[index][key] = e.value
      else
        data[index][key] = ''  
    } else if (key==='shelf_name') {
      data[index][key] = e.target.value
      this.onShelfSearch(data[index][key])
    } else
      data[index][key] = e.target.value
    
    this.setState({data:data})
  }

  onShelfSearch(query) {
    let {shelf} = this.state
    StockStore.loadLocationShelf(query,(result)=>{
      shelf = result.data.map((item,index)=>{
        return {label:item.shelf_name,id:item.shelf_name}
      })
      this.setState({shelf:shelf})
    })
  }

  onFormSelect(index,key,e,item) {
    let {data} = this.state
    data[index][key] = item.id
    this.setState({data:data})
  }

  onRowAdd(number){
    let {data} = this.state
    data = data.concat(this.newEmptyRow(number))
    this.pcInput = new Array(data.length).fill('')
    this.setState({data:data})
  }


  onSearch(index, query) {
    let that = this
    StockStore.loadSearchAnyProductDetail(query, function (result) {
      let options = result.data.map((item, index) => {
        return { 
          id: item.itemnum, 
          productCode: item.productcode, 
          itemnum: item.itemnum, 
          categoryName: item.cat_name, 
          detail: item.description, 
          pricePerUnit: item.price_per_unit, 
          unit:item.unit, 
          quantity:item.quantity, 
          stock_type:item.stock_type,
          container_quantity:item.container_quantity,
          container_unit:item.container_unit,
          is_container:item.is_container,
          quantity_per_container_unit:item.quantity_per_container_unit
        }
      })
      that.setState({ options: options })
    })
  }

  onTypeaheadChange(index,option){
    let {data} = this.state
    if(option.length===1){
      data[index].detail = option[0].detail
      data[index].quantity = 1
      data[index].price_per_unit = option[0].pricePerUnit
      if(option[0].itemnum!==undefined){
        data[index].itemnum = option[0].id
        data[index].productcode = option[0].productCode
        data[index].stock_type = option[0].stock_type
      }
    }
    this.setState({data:data})
  }

  onTypeaheadInputChange(index,query){
    let {data} = this.state
    data[index]['detail'] = query
    this.setState({data:data})
  }

  onTextKeyPress(index,key,target) {
    if(target.charCode===13){
      this.onSaveClick()
    }
  }

  onDeliveryChange() {
    let {isDelivery,doc} = this.state
    isDelivery = isDelivery?false:true
    if (isDelivery)
      doc.taxinvoice_no = doc.deliveryslip_no
    this.setState({isDelivery:isDelivery,doc:doc})
  }

  onCarSearchSelect(e) {
    let {doc} = this.state
    let car_info = ''
    doc.work_no =  e.work_no
    doc.car_registration_no = (typeof e.car_registration_no!=='undefined'?e.car_registration_no:e.Value)
    car_info = e.car_info
    doc.car_info = e.car_info
    this.setState({doc:doc,car_info:car_info})
  }

  onSearchCarKeyPress(e) {
    if (e.charCode === 13) {
      let {doc} = this.state
      let that = this
      WorkdocStore.loadWorkdocCarInfo(e.target.value,function(result){
        let item = result.data     
        if(item.work_no!==''){
          doc.work_no =  item.work_no         
          doc.car_registration_no = item.car_registration_no        
          that.setState({doc:doc,car_info:item.car_info,isSearchWork:true})
          ReactDOM.findDOMNode(that._description).focus()
        }else{
          doc.work_no = ''
          doc.car_registration_no = '';
          that.setState({doc:doc,car_info:that.props.messages['Car Registration Not Found'],isSearchWork:false})
        }
      })
    }
  }

  onSearchKeyPress(index,key,target) {
    if(target.charCode===13){
      let {data} = this.state
      let {messages} = this.props
      let foundIndex = -1
      let productcode = data[index][key];
      //Finding duplicate
      
      data.map((item,iindex)=>{
        if(item.productcode===productcode && iindex!==index){
          foundIndex = iindex
        }
      })
      if(foundIndex>=0){
        
        data[index].productcode = ''
        
      }else{
        this.setState({loading:true})
        
        AutopartStore.loadStockProductCode('any',productcode,(result)=>{
          if(result.data.length>0){
            let item = result.data[0]  
            data[index].productcode = item.productcode
            data[index].detail = item.description
            data[index].itemnum = item.itemnum
            data[index].price_per_unit = item.price_per_unit
            data[index].stock_type = item.stock_type
            if(index===data.length-1){
              //End index
              data = data.concat(this.newEmptyRow(1))
              this.pcInput[index+1] = ''
            }
            this.setState({loading:false,data:data})
            ReactDOM.findDOMNode(this.pcInput[index+1]).focus();
            
          }else{
            data[index].productcode = ''
            this.setState({loading:false,data:data})
            this._notificationSystem.addNotification({
              title:messages['Notice'],
              message: messages['Serial No Not Found']+' '+productcode+' '+messages['In Warehouse'],
              level: 'warning',
              position:'tc'
            });
          }
        })      
      }
      this.setState({data:data,rowBeep:foundIndex})
        setTimeout(()=>{ 
          this.setState({rowBeep:-1})
        }, 1500);
    } 
  }

  _renderMenuItemChildren(option, props, index) {
    let {messages} = this.props
    let quantityTitle = ''
    if(option.quantity>0){
      quantityTitle = ' '+messages['Have Number']+' '+option.quantity+' '+option.unit
    }

    if(option.pricePerUnit>0){
      return (
        <div key={option.id}>               
          <span>{option.detail} ({messages['Cate']}{option.categoryName}) - {option.pricePerUnit} {messages['Bath']} {quantityTitle}</span>
        </div>
      );
    }else{
      return (
        <div key={option.id}>               
          <span>{option.detail} {quantityTitle}</span>
        </div>
      );
    }
  }

  onPrintClick(){
    let {doc} = this.state
    let url = ''
    if (process.env.NODE_ENV == "development") {
      url  = './?startPage=PrintReceptionDoc&rc='+doc.reception_no
    } else{
      url = './pdf/v2/?startPage=PrintReceptionDoc&rc='+doc.reception_no
    }
    this.refs.iframe.loadUrl(url)
  }

  onSetItemlist(result) {
    let newItemlist = []
    newItemlist = result.data.map((item,index)=>{
      item = Object.assign({isCheck:false},item)
      return item
    })
    return newItemlist
  }

  onFixinglistOpen(field) {
    let {doc} = this.state
    if (field==='work') {
      WorkdocStore.loadPartReception(doc.work_no,(result)=>{
        let fixinglist = this.onSetItemlist(result)
        this.setState({showFixingList:true,fixinglist:fixinglist,modalType:field})
      })
    } else {
      PODocStore.loadPOOutRecord('RECEIVED',doc.purchase_order_no,(result)=>{
        let poreceivedlist = this.onSetItemlist(result)
        this.setState({showFixingList:true,poreceivedlist:poreceivedlist,modalType:field})
      })
    }  
  }

  onFixinglistSelect(field) {
    let {fixinglist,poreceivedlist,data} = this.state
    let itemSelect = []
    let itemlist = (field==='work'?fixinglist:poreceivedlist)
    itemlist.forEach((item,index)=>{
      let findDup = -1
      if (item.itemnum>0)
        findDup = data.findIndex(x=>x.itemnum===item.itemnum)
      if (item.isCheck&&findDup===-1)
        itemSelect.push(Object.assign({stock_type:""},item))
    })
    if (itemSelect.length>0) {
      let checkMap = false
      data.forEach((item,index)=>{
        if (item.itemnum===''&&item.detail==='') {
          itemSelect.forEach((sitem,sindex)=>{
            if (sindex===0) {
              item.productcode = sitem.productcode
              item.itemnum = sitem.itemnum
              item.detail = sitem.detail
              item.quantity = sitem.quantity
              item.part_by = sitem.part_by
              item.part_type = sitem.part_type
              if (field==='po'){
                item.price_per_unit = sitem.price_per_unit
                item.stock_type = sitem.stock_type
              }
            }
          })
          checkMap = true
          if (itemSelect.length>0)
            itemSelect.splice(0,1)
        }
      })

      if (!checkMap) {
        itemSelect.forEach((item,index)=>{
          if (field==='po') {
            data.push({
              productcode:item.productcode,
              itemnum:item.itemnum,
              detail:item.detail,
              quantity:item.quantity,
              price_per_unit:item.price_per_unit,
              part_by:item.part_by,
              part_type:item.part_type,
              stock_type:item.stock_type
            })
          } else {
            data.push({
              productcode:item.productcode,
              itemnum:item.itemnum,
              detail:item.detail,
              quantity:item.quantity,
              part_by:item.part_by,
              part_type:item.part_type,
              stock_type:item.stock_type
            })
          }  
        })
      }

      this.setState({data:data},()=>{
        this.onFixinglistHide()
      })
    } else {
      this.onFixinglistHide()
    }
  }

  onFixinglistHide() {
    this.setState({showFixingList:false,checkFixingListAll:false,modalType:'work'})
  }

  getRowClassName(item, index) {
    let { rowBeep } = this.state
    let className = (item.itemnum>0)?'':(item.detail.length>0&&item.itemnum<=0)?'bg-gray':''

    if (rowBeep === index) {
      className = 'bg-yellow'
    }
    return className
    return ''
  }

  getAmountPerRow(item) {
    let sum = 0
    let qty = (item.quantity===''||item.quantity===null||item.quantity===undefined||isNaN(item.quantity)?0:item.quantity*1)
    let price_per_unit = (item.price_per_unit===''||item.price_per_unit===null||item.price_per_unit===undefined||isNaN(item.price_per_unit)?0:item.price_per_unit*1)
    sum = price_per_unit*qty
    return sum
  }

  getSummary() {
    let {data} = this.state
    let sum = 0
    data.forEach((item,index)=>{
      sum += (this.getAmountPerRow(item)*1)
    })
    return sum
  }

  onPartTypeChange(index,e) {
    let {data} = this.state
    if (e!==null) {
      data[index].part_type = e.value
      this.setState({data:data})
    } else {
      data[index].part_type = ''
      this.setState({data:data})
    }
  }

  onPartByChange(index,e) {
    let {data} = this.state
    if (e!==null) {
      data[index].part_by = e.value
      this.setState({data:data})
    } else {
      data[index].part_by = ''
      this.setState({data:data})
    }
  }

  onLocationConfigOpen() {
    this.setState({showLocationConfig:true})
  }

  onLocationConfigHide() {
    this.setState({showLocationConfig:false})
  }

  onLocationConfigChange(index,field,e) {
    let {location_config} = this.state
    location_config[index][field] = e.target.value
    this.setState({location_config:location_config})
  }

  onLocationConfigSave() {
    let {location_config} = this.state
    StockStore.saveProductLocationConfig(location_config,(result)=>{
      if (result.status==='OK') {
        this.setState({location_config:result.data})
        this.onLocationConfigHide()
      }
    })
  }

  onLocationConfigDel(index) {
    let {location_config} = this.state
    if (location_config[index].location_config_id!=='')
      this.setState({showLocationConfirmDel:true,indexLocationDel:index})
    else {
      location_config.splice(index,1)  
      this.setState({location_config:location_config})
    }  
  }

  onLocationConfigRowAdd() {
    let {location_config} = this.state
    location_config.push({location_name:'',location_config_id:''})
    this.setState({location_config:location_config})
  }

  onLocationConfirmDel() {
    let {location_config} = this.state
    let index = this.state.indexLocationDel
    location_config[index] = Object.assign({mark_to_delete:true},location_config[index])
    this.setState({location_config:location_config},()=>{
      this.setState({showLocationConfirmDel:false,indexLocationDel:null})
    })
  }

  renderLocationConfigModal() {
    let {showLocationConfig,location_config} = this.state
    let checkHas = location_config.reduce((iitem,item,index)=>{
      if (typeof item.mark_to_delete==='undefined'||!item.mark_to_delete) {
        iitem.push(item)
      }
      return iitem
    },[])
    return(
        <Modal show={showLocationConfig} onHide={this.onLocationConfigHide.bind(this)}>
          <Modal.Header closeButton>
            <Modal.Title>เพิ่มคลังสินค้า</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='table-responsive'>
              <table className='table table-hover table-bordered-solid' style={{marginBottom:'0'}}>
                <thead>
                  <tr>
                    <th className='text-center' style={{width:'250px'}}>ชื่อคลังสินค้า</th>
                    <th className='text-center' style={{width:'50px'}}>ลบ</th>
                  </tr>
                </thead>
                <tbody>
                  {checkHas.length===0
                  ?
                  <tr><td colSpan={2}>ไม่พบข้อมูล</td></tr>
                  :
                  location_config.map((item,index)=>{
                    return(
                      <tr key={index} style={{display:(item.mark_to_delete==='undefined'||!item.mark_to_delete?'':'none')}}>
                        <td className='text-left'>
                          <FormControl
                            value={item.location_name}
                            onChange={this.onLocationConfigChange.bind(this,index,'location_name')}
                          />
                        </td>
                        <td className='text-center'>
                          <Button bsStyle='danger' onClick={this.onLocationConfigDel.bind(this,index)}><FontAwesome name='trash' /> ลบ</Button>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
            {this.renderLocationConfigNewItemButton()}
          </Modal.Body>
          <Modal.Footer>
            <Button className="btn-primary" onClick={this.onLocationConfigSave.bind(this)}>
              <FontAwesome name='save' /> บันทึก
            </Button>
            <Button onClick={this.onLocationConfigHide.bind(this)}>
              <FontAwesome name='remove' /> ปิด
            </Button>
          </Modal.Footer>
        </Modal>
    )
  }

  renderLocationConfigNewItemButton(){
    return (
      <Row style={{marginTop:'10px'}}>
        <Col md={12}>
          <ButtonToolbar>
            <Button className='bg-olive' onClick={this.onLocationConfigRowAdd.bind(this)}><FontAwesome name='plus'/>&nbsp;เพิ่มรายการ</Button>
          </ButtonToolbar>   
        </Col>    
      </Row>
    )
  }

  isLockRow(){
    let {doc} = this.state
    return (doc.status==='3' || doc.status==='4'|| doc.status==='2')          
  }

  renderRowData(){
    let {data,options,doc,shelf} = this.state
    let {messages,showInsurance,showStockLocation,enableReception} = this.props
    let location_options = this.state.location_config.map((item,index)=>{
      return {label:item.location_name,value:item.location_config_id}
    })
    return(
      data.map((item,index)=>{ 
        return(
          <tr key={index} className={this.getRowClassName(item,index)}>
            <td className='text-center'>{index+1}</td>
            <td className='data-column'>
              <FormControl 
              disabled={this.isLockRow()}
              className='text-left' 
              ref={(input) => { this.pcInput[index] = input; }} 
              value={item.productcode} 
              onChange={this.onFormChange.bind(this,index,'productcode')}
              onKeyPress={this.onSearchKeyPress.bind(this,index,'productcode')}
              />
            </td>
            <td className='data-column'>
              <AsyncTypeahead
                disabled={this.isLockRow()}
                allowNew={true}
                multiple={false}
                newSelectionPrefix={messages['Add New Item']+' : '}
                promptText={messages['Keypress For Searching']}
                searchText={messages['Searching']}
                emptyLabel={messages['Item Not Found']+' : '+item.detail}
                selected={[{ detail: item.detail }]}
                options={options}
                labelKey="detail"
                onSearch={this.onSearch.bind(this, index)}
                onChange={this.onTypeaheadChange.bind(this, index)}
                onInputChange={this.onTypeaheadInputChange.bind(this,index)}
                placeholder=""
                renderMenuItemChildren={this._renderMenuItemChildren.bind(this)}
              />
            </td>
            <td className='data-column text-center'>
              <FormControl 
                disabled={this.isLockRow()}
                type="number" 
                step="0.5" 
                className='text-center' 
                value={item.quantity} 
                onChange={this.onFormChange.bind(this,index,'quantity')}
              />
            </td>
            <td style={{display:(showStockLocation===true||showStockLocation==='true'?'':'none')}} className='data-column'>
              <Select 
              disabled={(doc.status==='4' || doc.status==='3'&&(enableReception!==true&&enableReception!=='true'))?true:false}
                value={item.location_config_id} 
                options={location_options}
                onChange={this.onFormChange.bind(this,index,'location_config_id')}
                placeholder='เลือก'
              />
            </td>
            <td style={{display:(showStockLocation===true||showStockLocation==='true'?'':'none')}} className='data-column text-center'>
              <CKAutocomplete
                disabled={(doc.status==='4' || doc.status==='3'&&(enableReception!==true&&enableReception!=='true'))?true:false}
                top={'-34px'}
                items={shelf}
                value={item.shelf_name}
                onChange={this.onFormChange.bind(this,index,'shelf_name')}
                onSelect={this.onFormSelect.bind(this,index,'shelf_name')}
                shouldItemRender={null}
              />
            </td>
            <td style={{display:(showInsurance===true||showInsurance==='true'?'':'none')}} className='data-column'>
              <Select
                disabled={this.isLockRow()}
                value={item.part_type}
                options={this.state.part_type_option}
                onChange={this.onPartTypeChange.bind(this,index)}
                placeholder='เลือก'
              />
            </td>
            <td style={{display:(showInsurance===true||showInsurance==='true'?'':'none')}} className='data-column'>
              <Select
                disabled={this.isLockRow()}
                value={item.part_by}
                options={this.state.part_by_option}
                onChange={this.onPartByChange.bind(this,index)}
                placeholder='เลือก'
              />
            </td>
            <td className='data-column text-center'>
              <FormControl 
                disabled={this.isLockRow()}
                className='text-right' 
                value={item.price_per_unit} 
                onChange={this.onFormChange.bind(this,index,'price_per_unit')}
              />
            </td>
            <td className='data-column text-right'>
              {item.quantity!==''&&item.price_per_unit!==''?this.getNumberFormat(this.getAmountPerRow(item)):''}
            </td>
            <td className='text-center'><Button style={{display:(this.isLockRow()?'none':'')}} bsStyle={'danger'} onClick={this.onDeleteRowClick.bind(this,index)}><FontAwesome name='close'/></Button></td>
          </tr>
        )
      })
    )
  }


  renderTable(){
    let {messages,showInsurance,showStockLocation} = this.props
    return (
      <div className='table-responsive'>
        <table className='table table-hover table-bordered-solid' style={{marginBottom:'0',minWidth:'1280px'}}>
          <thead>
            <tr >
              <th className='text-center' style={{width:'30px'}}>{messages['Number']}</th>
              <th className='text-center' style={{width:'180px'}}>{messages['Barcode/Product Code']}</th>
              <th className='text-center' style={{width:'300px'}}>{messages['Item Name']}</th>
              <th className='text-center' style={{width:'100px'}}>{messages['Quantity']}</th>
              <th style={{width:'100px',display:(showStockLocation===true||showStockLocation==='true'?'':'none')}} className='text-center'>
                เข้าสโตร์ <Button bsSize='xs' bsStyle='success' onClick={this.onLocationConfigOpen.bind(this)}><FontAwesome name='plus' /></Button>
              </th>
              <th style={{width:'90px',display:(showStockLocation===true||showStockLocation==='true'?'':'none')}} className='text-center'>Shelf</th>
              <th style={{width:'150px',display:(showInsurance===true||showInsurance==='true'?'':'none')}} className='text-center'>{messages['Type']}</th>
              <th style={{width:'150px',display:(showInsurance===true||showInsurance==='true'?'':'none')}} className='text-center'>{messages['Part By']}</th>     
              <th className='text-center' style={{width:'100px'}}>{messages['Price/Unit']}</th>
              <th className='text-center' style={{width:'100px'}}>{messages['Amount']}</th>            
              <th className='text-center' style={{width:'30px'}}>{messages['Delete']}</th>
            </tr>
          </thead>
          <tbody>
            {this.renderRowData()}
          </tbody>
          <tfoot>
            <tr>            
              <th colSpan={(showInsurance===true||showInsurance==='true')&&(showStockLocation===true||showStockLocation==='true')?9:(showInsurance===false||showInsurance==='false')&&(showStockLocation===false||showStockLocation==='false')?5:7} className='text-right'>{messages['Total Of Item']}</th>
              <th className='text-right'>{this.getNumberFormat(this.getSummary())}</th>
              <th className='text-right'></th>
            </tr>
          </tfoot>
        </table>
      </div>
    )
  }

  renderNewItemButton(){
    let {messages} = this.props
    let {isSearchWork,isSearchPOReceived} = this.state
    return (
      <Row style={{marginTop:'10px'}}>
        <Col md={12}>
          <ButtonToolbar>
            <Button className='bg-olive' onClick={this.onRowAdd.bind(this,1)}><FontAwesome name='plus'/>&nbsp;{messages['Add Item']}</Button>
            <Button className='bg-olive' onClick={this.onRowAdd.bind(this,10)}><FontAwesome name='plus'/>&nbsp;{messages['Add 10 Item']}</Button>
            {isSearchWork?<Button bsStyle='primary' onClick={this.onFixinglistOpen.bind(this,'work')}><FontAwesome name='search'/>&nbsp;ดึงรายการในใบจ็อบ</Button>:''}
            {isSearchPOReceived?<Button bsStyle='warning' onClick={this.onFixinglistOpen.bind(this,'po')}><FontAwesome name='search'/>&nbsp;ดึงรายการจากใบสั่งซื้อ</Button>:''}
          </ButtonToolbar>       
        </Col>
      </Row>
    )
  }

  
  renderStockStatus(){
    let {doc} = this.state
    if(doc.stock_recordid*1>0){
      return (<span className='label label-default'>{this.props.messages['Stock Cut']}</span>)
    }else{
      return (<span/>)
    }
  }

  onTextChange(key,e) {
    let {doc,validDoc} = this.state

    if (doc==='')
      doc = this.getEmptyDoc()

    if (key==='reception_by') {
      validDoc.reception_by.formValid = null
      validDoc.reception_by.validState = null
      this.setState({validDoc:validDoc})
    }

    if (key==='response_by') {
      validDoc.response_by.formValid = null
      validDoc.response_by.validState = null
      this.setState({validDoc:validDoc})
    }

    if (key==='purchase_order_no') {
      // validDoc.purchase_order_no.formValid = null
      // validDoc.purchase_order_no.validState = null
      // this.setState({validDoc:validDoc})
      if (e.target.value==='')
        this.setState({isSearchPOReceived:false})
    }

    doc[key] = e.target.value
    this.setState({doc:doc})
    if (key==='car_registration_no') {
      this.loadCarRegistrationNo(doc)
      if(e.target.value==='')
        this.setState({car_info:''})
    }
  }

  onTextSelect(key, e) { 
    let {doc,car_registration_no_list,validDoc} = this.state

    if (doc==="")
      doc = this.getEmptyDoc()
    
    if (key=='car_registration_no') {
      let value = ''
      let car_info = ''
      
      car_registration_no_list.forEach(function(item,index) {
        if(e===item.label) {
          value = item.id
          car_info = item.car_info
          doc.car_info = item.car_info
          doc.work_no =  item.work_no
        }  
      })

      doc[key] = value      
      this.setState({doc:doc,car_info:car_info})
      ReactDOM.findDOMNode(this._description).focus()
    } else {

      if (key==='reception_by') {
        validDoc.reception_by.formValid = null
        validDoc.reception_by.validState = null
        this.setState({validDoc:validDoc})
      }

      if (key==='response_by') {
        validDoc.response_by.formValid = null
        validDoc.response_by.validState = null
        this.setState({validDoc:validDoc})
      }

      doc[key] =  e
      this.setState({doc:doc})

      if (key==='reception_by')
        this.refs._response_by.onFocus()
      else if (key==='response_by')
        ReactDOM.findDOMNode(this._deliveryslip_no).focus()
    }
  }

  onEmpTextKeyPress(key,e) {
    if (e.charCode === 13) {
      e.preventDefault()
      let {messages} = this.props
      let {customerList,doc} = this.state
      let checkSearch = false
      let value = ''

      customerList.forEach(function(item,index) {
        if (item.emp_id===e.target.value) {
          checkSearch = true
          value = item.id
        }
      })

      if (checkSearch) {
        if (key==='reception_by') {
          doc[key] = value
          this.refs._response_by.onFocus()
        } else if (key==='response_by') {
          doc[key] = value
          ReactDOM.findDOMNode(this._deliveryslip_no).focus()
        }
      } else { 
        doc[key] = ''

        this._notificationSystem.addNotification({
          title: messages['Notice'],
          message: messages['Code Not Found']+' ' + e.target.value + ' '+messages['Please Try Again'],
          level: 'error',
          position: 'tc'
        });
      }  
      this.setState({doc:doc})
    }  
  }

  onCloseClick() {
    this.setState({isSearchWork:false,isSearchPOReceived:false})
    if (this.props.onClose!==undefined)
      this.props.onClose()
  }

  onFixinglistCheckAll() {
    let {checkFixingListAll,fixinglist,poreceivedlist,modalType} = this.state
    let check = true
    if (checkFixingListAll) {
      check = false
      checkFixingListAll = false
    } else
      checkFixingListAll = true  
    if (modalType==='work') {
      fixinglist = fixinglist.map((item,index)=>{
        item.isCheck = check
        return item
      })
    } else {
      poreceivedlist = poreceivedlist.map((item,index)=>{
        item.isCheck = check
        return item
      })
    }  
    this.setState({fixinglist:fixinglist,poreceivedlist:poreceivedlist,checkFixingListAll:checkFixingListAll})
  }

  onFixinglistCheck(index) {
    let {fixinglist,poreceivedlist,modalType} = this.state
    if (modalType==='work') {
      if (fixinglist[index].isCheck)
        fixinglist[index].isCheck = false
      else
        fixinglist[index].isCheck = true

      let checkAll = true
      fixinglist.forEach((item,index)=>{
        if (!item.isCheck)
          checkAll = false 
      })
      this.setState({fixinglist:fixinglist,checkFixingListAll:checkAll})
    } else {
      if (poreceivedlist[index].isCheck)
        poreceivedlist[index].isCheck = false
      else
        poreceivedlist[index].isCheck = true

      let checkAll = true
      poreceivedlist.forEach((item,index)=>{
        if (!item.isCheck)
          checkAll = false 
      })
      this.setState({poreceivedlist:poreceivedlist,checkFixingListAll:checkAll})
    }      
  }

  onSelectPO(poItem) {
    let {doc,validDoc} = this.state
    doc.car_registration_no = poItem.car_registration_no
    doc.purchase_order_no = poItem.purchase_order_no
    doc.shop_name = poItem.shop_name
    doc.work_no = poItem.work_no
    PODocStore.loadPOOutRecord('IMPORT_STOCK',poItem.purchase_order_no,(result)=>{
      let new_data = []
      new_data = result.data.map((item,index)=>{
        return Object.assign({stock_type:""},{detail:item.detail,productcode:item.productcode,quantity:item.quantity,stock_type:item.stock_type,bf_reception_item_id:'',reception_no:'',seq:'',price_per_unit:'',amount:''})
      })
      if (new_data.length < DEFAULT_ROW) {
        new_data = new_data.concat(this.newEmptyRow(DEFAULT_ROW - new_data.length))
      }
      validDoc.purchase_order_no.formValid = null
      validDoc.purchase_order_no.validState = null
      this.setState({doc:doc,showPO:false,data:new_data,validDoc:validDoc,isSearchPOReceived:true})
    })
  }

  onCustomerClick() {
    this.setState({showCustomer:true})
  }

  onSupplierPageSelect(item) {
    let { doc } = this.state
    doc['shop_id'] = item.shop_id
    doc['shop_name'] = item.name
    this.setState({ doc: doc })
  }

  onAutoCreateStockChange() {
    let {auto_create_stock} = this.state
    if (auto_create_stock)
      auto_create_stock = false
    else
      auto_create_stock = true
      
    this.setState({auto_create_stock:auto_create_stock})  
  }

  onToolTypeChange(e) {
    this.setState({toolType:e.value})
  }

  renderHeadTable() {
    let {doc,car_registration_no_list,customerList,validDoc,isSearchPOReceived} = this.state
    let {messages} = this.props
    return(
            <Form>
              <Row>
                <Col md={2} sm={2}>
                  <FormGroup>
                    <ControlLabel>{messages['Document Number']}</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4} sm={4}>
                  <FormGroup>
                    <FormControl type="text" placeholder={'<'+messages['Auto Generated Number']+'>'} value={doc.reception_no} className="input-dark" />
                  </FormGroup>
                </Col>
                <Col md={2} sm={2}>
                  <FormGroup>
                    <ControlLabel>{messages['Pickup Date']}<span className="color-red">*</span></ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={2} sm={2}>
                  <FormGroup>
                    <DatePicker
                      showIcon={true}
                      showFooter={true}
                      buddhistEra
                      popPlacement='bottom'
                      value={this.getDate(doc.added_date,'date')}
                      onChange={this.onDateChange.bind(this)}
                    />
                  </FormGroup>
                </Col>
                <Col md={2} sm={2}>
                  <FormGroup>
                    <CkTimePicker
                      value={this.getDate(doc.added_date,'time')}
                      onTimeSaved={this.onTimeChange.bind(this)}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={2} sm={2}>
                  <FormGroup
                    controlId={validDoc.reception_by.formValid}
                    validationState={validDoc.reception_by.validState}
                  >
                    <ControlLabel>{messages['Requester']}<span className="color-red">*</span></ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4} sm={4}>
                  <FormGroup
                    controlId={validDoc.reception_by.formValid}
                    validationState={validDoc.reception_by.validState}
                  >
                    <CKAutocomplete
                          top={'-34px'}
                          items={customerList}
                          value={doc.reception_by}
                          onChange={this.onTextChange.bind(this, 'reception_by')}
                          onSelect={this.onTextSelect.bind(this, 'reception_by')}
                          onKeyPress={this.onEmpTextKeyPress.bind(this, 'reception_by')}
                          ref='_reception_by'
                        />
                  </FormGroup>
                </Col>  
                <Col md={2} sm={2}>
                  <FormGroup
                    controlId={validDoc.response_by.formValid}
                    validationState={validDoc.response_by.validState}
                  >
                    <ControlLabel>{messages['Approvers']}<span className="color-red">*</span></ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4} sm={4}>
                  <FormGroup
                    controlId={validDoc.response_by.formValid}
                    validationState={validDoc.response_by.validState}
                  >
                    <CKAutocomplete
                          top={'-34px'}
                          items={customerList}
                          value={doc.response_by}
                          onChange={this.onTextChange.bind(this, 'response_by')}
                          onSelect={this.onTextSelect.bind(this, 'response_by')}
                          onKeyPress={this.onEmpTextKeyPress.bind(this, 'response_by')}
                          ref='_response_by'
                        />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={2} sm={2}>
                  <FormGroup>
                    <ControlLabel>เลขที่ใบส่งของ</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4} sm={4}>
                  <FormGroup>
                    <FormControl 
                      placeholder=""
                      value={ doc.deliveryslip_no } 
                      onChange={ this.onTextChange.bind(this, 'deliveryslip_no') }
                      ref={(input) => { this._deliveryslip_no = input }}
                    />
                  </FormGroup>
                </Col>
                <Col md={2} sm={2}>
                  <FormGroup>
                    <ControlLabel>เลขที่ใบกำกับ</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4} sm={4}>
                  <FormGroup style={{marginBottom:'0'}}>
                    <Checkbox
                      onChange={this.onDeliveryChange.bind(this)}
                      checked={this.state.isDelivery}
                      checkboxClass="icheckbox_square-blue"
                      increaseArea="20%"
                      label=" เลขที่เดียวกับใบส่งของ"
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControl 
                      placeholder=""
                      disabled={this.state.isDelivery}
                      value={ doc.taxinvoice_no } 
                      onChange={ this.onTextChange.bind(this, 'taxinvoice_no') }
                      ref={(input) => { this._taxinvoice_no = input }}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={2} sm={2}>
                  <FormGroup>
                    <ControlLabel>{messages['Car Registration']}</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={2} sm={2}>
                  <FormGroup>
                    <InputGroup>
                      <CKAutocomplete
                            items={car_registration_no_list}
                            value={doc.car_registration_no!==null?doc.car_registration_no:''}
                            onKeyPress={this.onSearchCarKeyPress.bind(this)}
                            onChange={this.onTextChange.bind(this, 'car_registration_no')}
                            onSelect={this.onTextSelect.bind(this, 'car_registration_no')}
                            ref='_car_registration_no'
                          />
                          <InputGroup.Addon className="btn" onClick={()=>this.setState({showCar:true})}>
                        <FontAwesome name='plus' />
                      </InputGroup.Addon>    
                    </InputGroup>    
                  </FormGroup>
                </Col>
                <Col md={2} sm={2}>
                  <FormGroup>
                    <Label bsStyle='default'>{this.state.car_info}</Label>
                  </FormGroup>
                </Col>
                <Col md={2} sm={2}>
                  <FormGroup style={{display:(this.props.showInsurance===true||this.props.showInsurance==='true'?'':'none')}}>
                    <ControlLabel>ประกัน/ลูกค้า</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4} sm={4}>
                  <FormGroup style={{display:(this.props.showInsurance===true||this.props.showInsurance==='true'?'':'none')}}>
                    <FormControl value={doc.customer_name===null?'':doc.customer_name} onChange={this.onTextChange.bind(this,'customer_name')} />
                  </FormGroup>
                </Col>
              </Row> 
              <Row>
                <Col md={2} sm={2}>
                  <FormGroup
                    // controlId={validDoc.purchase_order_no.formValid}
                    // validationState={validDoc.purchase_order_no.validState}
                  >
                    <ControlLabel>{messages['Order Number']}</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4} sm={4}>
                  <FormGroup
                    // controlId={validDoc.purchase_order_no.formValid}
                    // validationState={validDoc.purchase_order_no.validState}
                  >
                    <InputGroup>
                      <FormControl value={doc.purchase_order_no===null?'':doc.purchase_order_no} onChange={this.onTextChange.bind(this,'purchase_order_no')} />
                      <InputGroup.Addon onClick={()=>{this.setState({showPO:true})}}><FontAwesome name='search' /></InputGroup.Addon>
                    </InputGroup>
                  </FormGroup>
                </Col>
                <Col md={2} sm={2}>
                  <FormGroup>
                    <ControlLabel>{messages['Shop Name']}</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4} sm={4}>
                  <FormGroup>
                    {!isSearchPOReceived?
                    <InputGroup>
                      <FormControl value={doc.shop_name===null?'':doc.shop_name} onChange={this.onTextChange.bind(this,'shop_name')} />
                      <InputGroup.Addon onClick={this.onCustomerClick.bind(this)}><FontAwesome name='plus' /></InputGroup.Addon>
                    </InputGroup>
                    :
                    <FormControl readOnly={isSearchPOReceived} value={doc.shop_name===null?'':doc.shop_name} onChange={this.onTextChange.bind(this,'shop_name')} />
                    }  
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={2} sm={2}>
                  <FormGroup>
                    <ControlLabel>{messages['Description']}</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4} sm={4}>
                  <FormGroup>
                    <FormControl ref={(input) => { this._description = input }} value={doc.description===null?'':doc.description} onChange={this.onTextChange.bind(this,'description')} />
                  </FormGroup>
                </Col>
                <Col md={2} sm={2}>
                  <FormGroup>
                    <ControlLabel>{messages['Location']}</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4} sm={4}>
                  <FormGroup>
                    <FormControl value={doc.location===null?'':doc.location} onChange={this.onTextChange.bind(this,'location')} />
                  </FormGroup>
                </Col>
              </Row>
            </Form>
    )
  }

  renderPOModal() {
    let {showPO,doc} = this.state
    let workNo = doc.work_no
    if (doc.car_registration_no==='')
      workNo = ''
    return(
        <Modal show={showPO} onHide={()=>{this.setState({showPO:false})}} dialogClassName='fullwidth-dialog'>
          <Modal.Header closeButton>
            <Modal.Title>{this.props.messages['Select PO']}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ReportPurchaseOrderPage
              workNo={workNo}
              mode={'modal'}
              docType={'stock-receive'}
              showNewButton={false}
              onSelectPO={this.onSelectPO.bind(this)}
            />
          </Modal.Body>
        </Modal>
    )
  }

  renderRemark(){
    let {remark} = this.state.doc
    return (
      <Row>
        <Col md={3}>
          <FormGroup>
            <ControlLabel>{this.props.messages['Remark']}</ControlLabel>
            <InputGroup>            
              <FormControl value={remark} componentClass="textarea" style={{width:'400px',height:'150px'}}
              onChange={this.onTextChange.bind(this,'remark')}/>            
            </InputGroup>            
          </FormGroup>
        </Col>
      </Row>
    )
  }

  renderFixingListRowData() {
    let {fixinglist,poreceivedlist,modalType} = this.state
    let itemlist = (modalType==='work'?fixinglist:poreceivedlist)
    if (itemlist.length===0) {
      return(<tr><td colSpan={3}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        itemlist.map((item,index)=>{
          return(
            <tr key={index}>
              <td className='text-center'>
                    <Checkbox
                      onChange={this.onFixinglistCheck.bind(this,index)}
                      checked={item.isCheck}
                      checkboxClass="icheckbox_square-blue"
                      increaseArea="20%"        
                      label=''          
                    />
              </td>
              <td className='text-left'>{item.detail}</td>
              <td className='text-center'>{item.quantity}</td>
            </tr>
          )  
        })
      )
    }
  }

  renderFixingListTable() {
    let {checkFixingListAll} = this.state
    return(
      <div className='table-responsive'>
        <table className='table table-hover table-bordered-solid'>
          <thead>  
            <tr>
              <th style={{width:'50px'}} className='text-center'>
                <Checkbox
                  checked={checkFixingListAll}
                  onChange={this.onFixinglistCheckAll.bind(this)}
                  checkboxClass="icheckbox_square-blue"
                  increaseArea="20%"        
                  label=''
                />
              </th>
              <th style={{width:'250px'}} className='text-center'>รายการ</th>
              <th style={{width:'10px'}} className='text-center'>จำนวน</th>
            </tr>
          </thead>  
          <tbody>
            {this.renderFixingListRowData()}
          </tbody>
        </table>
      </div>
    )
  }
  
  renderFixingListModal() {
    let {showFixingList,modalType} = this.state
    return(
      <Modal show={showFixingList} onHide={this.onFixinglistHide.bind(this)} dialogClassName='fullwidth-dialog'>
        <Modal.Header closeButton>
          <Modal.Title>เลือกอะไหล่จากใบ{(modalType==='work'?'จ็อบ':'สั่งซื้อ')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.renderFixingListTable()}
        </Modal.Body>
        <Modal.Footer>
          <div className='pull-right'>
            <Button bsStyle='primary' onClick={this.onFixinglistSelect.bind(this,modalType)}><FontAwesome name='shopping-cart' />&nbsp;ใส่เข้าไปในรายการรับของ</Button>
            <Button onClick={this.onFixinglistHide.bind(this)}><FontAwesome name='close' />&nbsp;ปิด</Button>
          </div>
        </Modal.Footer>
      </Modal>
    )
  }

  renderStatus(){
    let {doc} = this.state
    if(doc.status==='3'){
      return (<div className='label label-warning'><FontAwesome name='wpforms'/>  รับของแล้ว</div>)
    }else if(doc.status==='4'){
      return (<div className='label label-success'><FontAwesome name='industry'/> นำเข้าคลังแล้ว</div>)
    }else if(doc.status==='2'){
      return (<div className='label label-purple'><FontAwesome name='wrench'/> นำไปซ่อมแล้ว</div>)      
    }else{
      return (<div className='label label-default'><FontAwesome name='clock-o'/> [Draft/เริ่มต้น]</div>)
    }
  }

  renderAutoCreateStock() {
    let {messages} = this.props
    return(
          <div>
            <p>ถ้ารายการอะไหล่นี้ไม่มีอยู่ในคลังให้ทำการ</p>
            <Form inline>
              <FormGroup>
                <Checkbox
                  onChange={this.onAutoCreateStockChange.bind(this)}
                  checked={this.state.auto_create_stock}
                  checkboxClass="icheckbox_square-blue"
                  increaseArea="20%"
                  label={' '+messages['Automatic Create']}
                >
                </Checkbox>
              </FormGroup>{' '}
              {this.state.auto_create_stock
              ?
              <FormGroup>
                <Select
                  clearable={false}
                  options={this.optionsToolType}
                  value={this.state.toolType}
                  onChange={this.onToolTypeChange.bind(this)}
                  style={{width:'130px'}}
                />
              </FormGroup>  
              :''}
            </Form>
          </div>
    )
  }

  render(){
    let {loading,doc,isSave,isRecieved,mpNo,showCustomer} = this.state
    let {messages,enableReception}  = this.props
    return (
      <div>
        <Box loading={loading}>
          <Box.Header className='text-center'>
            <Box.Title>
              {this.props.title} {mpNo} {this.renderStatus()}
            </Box.Title>
            <Box.Tools >
              <ButtonToolbar>                                            
                <Button                             
                  className={'bg-maroon ' +(doc.seq_no>0?'':'hide')}
                  onClick={this.onPrintClick.bind(this)}
                >
                  <FontAwesome name='print'/>&nbsp;{messages['Print Document']}
                </Button>
              </ButtonToolbar>                     
            </Box.Tools> 
          </Box.Header>
          <Box.Body>
            <div className='stock-any-export'>
              {this.renderHeadTable()}
              {this.renderTable()}
              {this.renderNewItemButton()}       
              {this.renderRemark()}        
            </div>
            <IframeModal ref='iframe' title={messages['Print Document']} />
            <NotificationSystem ref="notificationSystem" />    
          </Box.Body>    
          <Box.Footer>
            <ButtonToolbar className='pull-right'>
              <Button style={{display:(((this.isLockRow() || doc.seq_no=="" ) ||(doc.seq_no>0 && doc.status!=="0"))?'none':'')}} disabled={!isRecieved?true:false} bsStyle='warning' onClick={this.onRecievedClick.bind(this)}><FontAwesome name='wpforms' />&nbsp;{messages['Recieved']}</Button>
              <Button style={{display:(doc.status==='3'&&(enableReception===true||enableReception==='true') && doc.work_no ?'':'none')}} disabled={!isRecieved?true:false} bsStyle='purple' onClick={this.onExportWorkClick.bind(this)}><FontAwesome name='wrench' />&nbsp;นำไปซ่อม</Button>
              <Button style={{display:(doc.status==='3'&&(enableReception===true||enableReception==='true')?'':'none')}} disabled={!isRecieved?true:false} bsStyle='success' onClick={this.onImportStockClick.bind(this)}><FontAwesome name='industry' />&nbsp;นำเข้าคลัง</Button>
              <Button style={{display:(doc.status==='3'&&(enableReception!==true&&enableReception!=='true')?'none':'')}} disabled={!isSave?true:false} bsStyle='primary' onClick={this.onSaveClick.bind(this)}><FontAwesome name='save' />&nbsp;{messages['Save']}</Button>              
              <Button onClick={this.onCloseClick.bind(this)}><FontAwesome name='close' />&nbsp;{messages['Close']}</Button>
            </ButtonToolbar>
          </Box.Footer>    
        </Box>
        {this.renderPOModal()}
        {this.renderFixingListModal()}
        <SupplierPageModal 
          show={showCustomer} 
          onHide={() => { this.setState({ showCustomer:false }) }}
          onSelect={this.onSupplierPageSelect.bind(this)}
        />
        <ConfirmPopup
            show={this.state.showConfirm}
            onHide={()=>{this.setState({showConfirm:false})}}
            title={'ยืนยัน'}
            message={'ต้องการยืนยันรับของหรือไม่ ? ไม่สามารถกลับมาแก้ไขรายการได้'}
            onConfirm={this.onConfirmRecievedClick.bind(this)}
        />
        <ConfirmPopup
            show={this.state.showImStockConfirm}
            onHide={()=>{this.setState({showImStockConfirm:false})}}
            title={'ยืนยัน'}
            message={'ต้องการยืนยันนำอะไหล่เข้าคลังหรือไม่ ? ไม่สามารถกลับมาแก้ไขรายการได้'}
            renderEle={this.renderAutoCreateStock.bind(this)}
            minHeight={'1px'}
            onConfirm={this.onConfirmImportStockClick.bind(this)}
        />
        <ConfirmPopup
            show={this.state.showExWorkConfirm}
            onHide={()=>{this.setState({showExWorkConfirm:false})}}
            title={'ยืนยัน'}
            message={'ต้องการยืนยันนำอะไหล่ไปซ่อมหรือไม่ ? ไม่สามารถกลับมาแก้ไขรายการได้'}
            onConfirm={this.onConfirmExportWorkClick.bind(this)}
        />        
        <SearchCarButton
          show={this.state.showCar}
          onHide={()=>{this.setState({showCar:false})}}
          onSelect={this.onCarSearchSelect.bind(this)}
        />
        <ConfirmPopup
          show={this.state.showLocationConfirmDel}
          message='ยืนยันทำรายการลบหรือไม่ ?'
          onHide={()=>{this.setState({showLocationConfirmDel:false,indexLocationDel:null})}}
          onConfirm={this.onLocationConfirmDel.bind(this)}
        />
        {this.renderLocationConfigModal()}
      </div>
    )
  }
}

ReceptionDoc.defaultProps = {
  show:false,
  showHead:true,
  openInoutPrintAfterSubmit:true,
  title:'รายการรับ',
  type:''
}
export default connect(
  (state) => ({messages: state.message.view.doc.ReceptionDoc}),null,null,{withRef:true},
)(ReceptionDoc);



// WEBPACK FOOTER //
// ./src/view/doc/ReceptionDoc.js